import { z } from "zod";
import { SmartCreationReviewFieldSchema } from "./changes";
import { SmartCreationReviewEntityRefSchema } from "./values";

export const SmartCreationReviewDiagnosticSchema = z
  .object({
    severity: z.enum(["info", "warning", "error"]),
    code: z.enum([
      "preview_refresh_required",
      "stale_plan_revision",
      "capability_changed",
      "invalid_name",
      "invalid_budget",
      "invalid_bid",
      "invalid_placement",
      "invalid_target",
      "invalid_negative",
      "all_campaigns_excluded",
      "preflight_failed",
    ]),
    blocking: z.boolean(),
    entity: SmartCreationReviewEntityRefSchema.nullable(),
    field: SmartCreationReviewFieldSchema.nullable(),
    message: z.string().trim().min(1).max(1_000),
  })
  .strict()
  .superRefine((diagnostic, ctx) => {
    if (diagnostic.blocking && diagnostic.severity !== "error") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Blocking Review diagnostics must use error severity",
        path: ["severity"],
      });
    }
  });
export type SmartCreationReviewDiagnostic = z.infer<typeof SmartCreationReviewDiagnosticSchema>;
